import { NormalizedStorageObject } from "../../../../services/api/instances/storageApi/types/object_types";
import {
  StorageObjectValue,
  TObjectShareResponse,
} from "../../../../services/api/instances/storageApi/types/service_types";

export const getSharedFolderChildIds = (
  id: number,
  sharedObjects: TObjectShareResponse[],
  entities: Record<string, NormalizedStorageObject<StorageObjectValue>>,
) => {
  const sharedObject = sharedObjects.find((o) => o.id === id);
  const parent = entities?.[sharedObject?.object_id ?? ""];
  const childIds = parent.childrenIds
    ? parent.childrenIds.map((c) => Number(c))
    : [];
  if (!childIds) return [id];
  const sharedChildIds = sharedObjects
    .map((obj) => (childIds.includes(obj.object_id) ? obj.id : null))
    .filter((o) => o !== null);
  return [...sharedChildIds, id];
};
